@if(baseData(); as projectBaseData){
<app-card [titleKey]="'general.basicData'">
  <app-info-label [label]="translateKey + 'alreadyGivenDataInfo'" />
  <div class="row flex-between-center">
    <div class="col-6 my-2">
      <app-display-field
        [label]="'general.currency'"
        [displayText]="projectBaseData.currency"
      />
    </div>
    <div class="col-6 my-2">
      <app-display-field
        [label]="'general.location'"
        [displayText]="projectBaseData.country + ', ' + projectBaseData.city"
      />
    </div>
    <div class="col-6 my-2">
      <app-display-field
        [label]="translateKey + 'typeOfFunding'"
        [displayText]="(projectFoundingTranslationKey() ?? '') | translate"
      />
    </div>
    <div class="col-6 my-2">
      <app-display-field
        [label]="translateKey + 'byInvestmentCategory'"
        [displayText]="'1'"
      />
    </div>
  </div>
</app-card>
}
